import { InputLabel, TextField } from '@mui/material'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import { Controller } from 'react-hook-form'
import { inputLabelClasses } from '@mui/material/InputLabel'

const TextFields = ({ control, name, label, errorMsg, ...props }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          {...props}
          fullWidth
          margin="normal"
          required
          label={label}
          error={!!errorMsg}
          helperText={errorMsg || ''}
          InputProps={{
            sx: {
              '&:focus-within fieldset, &:focus-visible fieldset': {
                border: '2px solid #7966eb!important'
              }
            }
          }}
          InputLabelProps={{
            sx: {
              [`&.${inputLabelClasses.shrink}`]: {
                color: '#7966eb!important'
              }
            }
          }}
        />
      )}
    />
  )
}

export default TextFields

export const SelectField = ({
  control,
  name,
  className,
  input_label,
  label,
  data
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControl fullWidth className={className}>
          <InputLabel id="demo-simple-select-label"> {input_label} </InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            {...field}
            label={label}
            data_testid="Select-a2b2607e-f559-4aa2-8d4f-6144d632db05"
          >
            {data}
          </Select>
        </FormControl>
      )}
    />
  )
}
